import * as Sentry from "@sentry/browser"
import React from "react"
import { useTranslation } from "react-i18next"

import { ContactForm } from "~/components/ContactForm/ContactForm"
import { Layout } from "~/components/Layout/Layout"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import { Annual } from "./components/Annual/Annual"
import { Calendar } from "./components/Calendar/Calendar"
import { Committee } from "./components/Committee/Committee"
import { ContentBlueForm } from "./components/ContentBlueForm/ContentBlueForm"
import { Hero } from "./components/Hero/Hero"
import { Obligation } from "./components/Obligation/Obligation"
import { Ratings } from "./components/Ratings/Ratings"
import { Stock } from "./components/Stock/Stock"
import { UsefullLinks } from "./components/UsefullLinks/UsefullLinks"

const InvestorsAndShareholders: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout headerTheme="onDark" title={t("page.investors-and-shareholders")}>
      <Hero />
      <Wrapper>
        <Stock />
        <Obligation />
      </Wrapper>
      {/*<Annual />*/}
      {/*<Ratings />*/}
      <Committee />
      <Calendar />
      <UsefullLinks />
      <ContactForm
        content={() => <ContentBlueForm />}
        title={t("investors-and-shareholders.BlueForm.Title")}
        showMobileText
      />
    </Layout>
  )
}

export default InvestorsAndShareholders
